export const addCapitalCall = obj => ({
    investmentFund: `/api/investment_funds/${obj.investmentFundId}`,
    percentage: obj.percentage,
    issueDate: obj.date,
    reason: obj.reason,
});
